import { toggleLoader, toggleSpinnerLoader } from '../_PandoNexis/Actions/GenericLoader.action';
import { translate } from '../Services/translation';
import { pnConfirm } from '../_PandoNexis/Actions/PnConfirm.action';
import { post } from '../Services/http';
export const catchError = (ex, onError, showErrorAlert = false, addonName = '', errorAlertText = '') => (dispatch) => {
    dispatch(toggleLoader(false));
    toggleSpinnerLoader(false);
    const apiURL = '/api/monitoring/createLogPost';
    if (showErrorAlert) {
        const errorTitle = translate('common.genericerror.title');
        const errorText = errorAlertText || translate('common.genericerror.text');
        dispatch(pnConfirm(errorTitle, errorText, false, false, 'warning', false));
    }

    if (ex.response) {
        ex.response.json().then((error) => {
            const errObj = {
                ...error,
                status: ex.response.status,
                pageUrl: ex.response.url,
                addonName,
            };

            return post(apiURL, errObj)
                .then((response) => response.json())
                .then((result) => {
                    dispatch(receive(result));
                })
                .catch((ex) => { });

            //console.log("Error:", errObj);
            dispatch(onError(error));
        });
    } else {
        const errObj = {
            ...ex.response,
            addonName,
        };
        return post(apiURL, errObj)
            .then((response) => response.json())
            .then((result) => {
                dispatch(receive(result));
            })
            .catch((ex) => { });
        //console.log("Error:", errObj);
        dispatch(onError(ex));
    }
};